import React from "react";
import PropTypes from "prop-types";
import { Row, Col, PageHeader, Tag, Tabs } from "antd";
import CreditPolicy from "../templates/credit-policy";
import DocumentsPolicy from "../templates/documents-policy";
import UsersPermissions from "../templates/users-permissions";
import BusinessAnalysis from "../templates/business-analysis";

const tabs = [
    {
        label: "Summary",
        key: "summary"
    },
    {
        label: "Analysis",
        key: "program_analysis",
        component: BusinessAnalysis
    },
    {
        label: "Credit Policy",
        key: "credit_policy",
        component: CreditPolicy
    },
    {
        label: "Documents Policy",
        key: "documents_policy",
        component: DocumentsPolicy
    },
    {
        label: "Users and Permissions",
        key: "users_and_permissions",
        component: UsersPermissions
    },
    {
        label: "Repayments",
        key: "repayments"
    },
    {
        label: "Sanction Kit Format",
        key: "repayments"
    },
];


class LendersView extends React.Component {

    state ={
        activeTab: tabs[2].key
    };

    getContent() {

        const activeTab = tabs.find(_ => _.key === this.state.activeTab);

        if(activeTab) {
            const TabComponent = activeTab.component;
            return <TabComponent/>;
        }
        return null;

    }


    onTabChange = key => {
        this.setState({
            activeTab: key
        });
    }

    render() {
        return (
            <Row>
                <Col>
                    <PageHeader 
                        ghost={false}
                        title={"Muthoot Fincorp"}
                        subTitle={"Bank Code: MF"}
                        avatar={{ src: `${process.env.FILE_DOWNLOAD_URL}/starfin_logo.png` }}
                        tags={<Tag color="blue">Active</Tag>}
                        footer={<Tabs size={"small"} activeKey={this.state.activeTab} onChange={this.onTabChange}>
                            {tabs.map(_ => <Tabs.TabPane key={_.key} tab={_.label}/>)}
                        </Tabs>}
                    >
                    </PageHeader>
                </Col>
                <Col style={{ padding: "48px 120px"}}>
                    {this.getContent()}
                </Col>
            </Row>
        );
    }
}

LendersView.propTypes = {
    route: PropTypes.object
};

export default LendersView;